// Theme configuration for easy customization
export const defaultTheme = {
  colors: {
    heroBg: '#1A202C',
    partnersBg: '#2D3748',
    accentYellow: '#FBBF24',
    textWhite: '#FFFFFF',
    buttonBorder: '#FFFFFF',
    shirtBlue: '#1E3A8A',
    poloRed: '#DC2626',
  },
  fonts: {
    primary: 'Inter',
    fallback: 'system-ui, sans-serif',
  },
  content: {
    name: 'Yomuma Likessa',
    tagline: 'Empower Startups. Strengthen Ecosystems.',
    mainHeading: 'This is the moment to build stronger startups alongside programs that truly empower them.',
    primaryButtonText: "Let's Co-Create",
    secondaryButtonText: 'Get More Leads',
    freeTrainingText: 'Get in Touch',
  },
  navigation: [
    { label: 'Accelerators', hasDropdown: false },
    { label: 'KPI Score', hasDropdown: false },
    { label: 'ScoreApp', hasDropdown: false },
    { label: 'Books', hasDropdown: true }
  ],
  partners: [
    { name: 'DOAC', logo: null },
    { name: 'Forbes', logo: null },
    { name: 'FT FINANCIAL TIMES', logo: 'FT', isSquare: true },
    { name: 'The Telegraph', logo: null },
    { name: 'Entrepreneur', logo: null }
  ],
  images: {
    heroImage: '/Banne_5.png', // Your custom hero image
  }
};

// Theme customization functions
export const createCustomTheme = (customizations = {}) => {
  return {
    colors: { ...defaultTheme.colors, ...customizations.colors },
    fonts: { ...defaultTheme.fonts, ...customizations.fonts },
    content: { ...defaultTheme.content, ...customizations.content },
    navigation: customizations.navigation || defaultTheme.navigation,
    partners: customizations.partners || defaultTheme.partners,
    images: { ...defaultTheme.images, ...customizations.images },
  };
};

// Helper function to apply theme to CSS variables
export const applyThemeToCSS = (theme) => {
  const root = document.documentElement;
  
  // Apply color variables
  Object.entries(theme.colors).forEach(([key, value]) => {
    root.style.setProperty(`--${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`, value);
  });
  
  // Apply font variables
  root.style.setProperty('--font-family', `${theme.fonts.primary}, ${theme.fonts.fallback}`);
};

// Example custom themes
export const exampleThemes = {
  // Blue theme variant
  blueTheme: createCustomTheme({
    colors: {
      heroBg: '#1E3A8A',
      partnersBg: '#1E40AF',
      accentYellow: '#3B82F6',
    }
  }),
  
  // Green theme variant
  greenTheme: createCustomTheme({
    colors: {
      heroBg: '#064E3B',
      partnersBg: '#065F46',
      accentYellow: '#10B981',
    }
  }),
  
  // Purple theme variant
  purpleTheme: createCustomTheme({
    colors: {
      heroBg: '#581C87',
      partnersBg: '#6B21A8',
      accentYellow: '#A855F7',
    }
  })
};
